import { Exclude, Type } from 'class-transformer';

import { Listitem } from './listitem.model';

export class List {
	id!: number;
	slug!: string;
	descr?: string;
	valutetype?: string;
	editable?: number;

	@Exclude({ toPlainOnly: true })
	@Type(() => Listitem)
	items?: Listitem[];
}
